import Vue from "vue";
import Vuex from "vuex";
import axios from "../plugins/axios";
import plainAxios from "axios";
import api from "../api";
import { ui } from "./ui";
import vaccount from "./user-vaccounts";
import { release as releasePushToken } from "../plugins/push-token";

Vue.use(Vuex);

var refreshToken = sessionStorage.getItem("refreshToken");
var accessToken = sessionStorage.getItem("accessToken");

var payload = JSON.parse(atob(accessToken?.split?.(".")?.[1] ?? "") || "{}");
var tokenHeader = JSON.parse(atob(accessToken?.split?.(".")?.[0] ?? "") || "{}");
var scope = payload?.scope || [];
var _cert_MypageExchange = sessionStorage.getItem("_cert_MypageExchange");

const store = new Vuex.Store({
    state: {
        refreshToken,
        accessToken,
        payload,
        tokenHeader,
        scope,
        _cert_MypageExchange,
        user: null,

        recentProducts: [],
        pickupItems: [],
    },
    mutations: {
        login(state, { refreshToken, accessToken }) {
            state.refreshToken = refreshToken;
            state.accessToken = accessToken;

            state.payload = JSON.parse(atob(accessToken?.split(".")[1] || "") || "{}");
            state.scope = state.payload?.scope || [];

            axios.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;

            sessionStorage.setItem("refreshToken", refreshToken);
            sessionStorage.setItem("accessToken", accessToken);
        },

        logout(state) {
            state.refreshToken = undefined;
            state.accessToken = undefined;

            state.payload = {};
            state.scope = [];

            axios.defaults.headers.common["Authorization"] = "";

            sessionStorage.removeItem("refreshToken");
            sessionStorage.removeItem("accessToken");
            sessionStorage.removeItem("_cert_MypageExchange");
        },

        set_cert_MypageExchange(state, { _cert }) {
            state._cert_MypageExchange = _cert;
            sessionStorage.setItem("_cert_MypageExchange", _cert);
        },

        setUser(state, { user }) {
            state.user = user;
        },

        recent(state, product) {
            if (!state.recentProducts.find((item) => item._id == product._id)) state.recentProducts.unshift(product);
            if (3 < state.recentProducts.length) state.recentProducts.pop();
        },

        pickup(state, cartItems) {
            state.pickupItems = cartItems;
        },

        checkout(state) {
            state.pickupItems = [];
        },
    },
    actions: {
        async login({ dispatch, commit }, { username, password, ci }) {
            var { refreshToken } = await api.auth.getRefreshToken({ username, password, ci });
            var { accessToken } = await api.auth.getAccessToken(refreshToken);

            commit("login", { refreshToken, accessToken });
            dispatch("getUser");
        },

        async logout({ state, commit }) {
            // 토큰을 먼저 잡아 두고 로컬 상태부터 비운다. 이미 로그아웃된 상태면 토큰이 없어 요청하지 않는다
            const refreshToken = state.refreshToken;

            // 이 브라우저의 웹 푸시 토큰을 서버에서 지운다. 해제 요청은 keepalive 라 기다리지 않는다.
            // 이 탭에서 등록이 진행 중일 때만 그 끝을 최대 3초 기다린다(실패 무시)
            await releasePushToken();

            commit("logout");

            // 서버 세션(이 refreshToken) 삭제. accessToken(5분)이 만료된 뒤에도 지울 수 있게 refreshToken으로 보낸다.
            // 401 인터셉터가 없는 axios로 보내 refresh 실패 → logout 반복을 막는다. 실패는 무시한다
            if (refreshToken) {
                plainAxios.delete("/api/auth/refreshToken", { headers: { Authorization: `Bearer ${refreshToken}` } }).catch(() => {});
            }
        },

        async getUser({ commit }) {
            const { me } = await api.v1.me.profile.get();
            commit("setUser", { user: me });
        },

        async refresh({ commit }, { refreshToken, _cert }) {
            var { accessToken } = await api.auth.getAccessToken(refreshToken, _cert);

            commit("login", { refreshToken, accessToken });
        },

        addToCart({ commit }, _carts) {
            commit("addToCart", _carts);
        },

        pickup({ commit }, { carts }) {
            commit("pickup", carts);

            return Promise.resolve();
        },

        checkout(context) {
            context.commit("checkout");
        },

        recent({ commit }, product) {
            commit("recent", product);
        },
    },
    modules: {
        ui,
        vaccount,
    },
});

Vue.use({
    install: function(Vue, options) {
        Vue.prototype.$scopes = store.state.scope;
        Vue.prototype.$hasScope = (scopes) => {
            return store.state.scope.find((scope) => scopes.includes(scope));
        };
    },
});

export default store;
